var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPreferencesIconsTicketing = function SvgPreferencesIconsTicketing(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "18px",
    viewBox: "0 0 15 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "preferences_icons_Ticketing")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "preferences_icons_Ticketing",
    transform: "translate(0.200000, 0.300000)",
    fill: "#63758D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2,2.05 L11.1,2.05 L11.1,1.65 C11.1,1.35 10.9,1.15 10.6,1.15 L8.9,1.15 C8.7,0.75 8.3,0.35 7.9,0.15 C7.4,-0.05 6.8,-0.05 6.3,0.15 C5.7,0.35 5.4,0.65 5.1,1.15 L3.5,1.15 C3.2,1.15 3,1.35 3,1.65 L3,2.15 L0.8,2.15 C0.4,2.15 0,2.55 0,2.95 L0,16.65 C0,17.05 0.4,17.45 0.8,17.45 L13.1,17.45 C13.5,17.45 13.9,17.05 13.9,16.65 L13.9,2.85 C13.9,2.45 13.6,2.05 13.2,2.05 Z M12.4,16.15 L1.6,16.15 C1.5,16.15 1.4,16.15 1.3,16.05 C1.2,15.95 1.2,15.95 1.2,15.75 L1.2,3.65 C1.2,3.45 1.4,3.25 1.6,3.25 C1.6,3.25 1.6,3.25 1.6,3.25 L3,3.25 L3,3.75 C3,3.95 3,4.15 3.2,4.35 C3.3,4.45 3.5,4.55 3.8,4.55 L10.3,4.55 C10.5,4.55 10.7,4.45 10.9,4.35 C11,4.25 11.1,4.05 11.1,3.75 L11.1,3.25 L12.4,3.25 C12.6,3.25 12.8,3.35 12.8,3.65 L12.8,15.85 C12.8,15.95 12.6,16.15 12.4,16.15 L12.4,16.35 L12.4,16.15 L12.4,16.15 Z M4.2,3.35 L4.2,2.35 L6.2,2.35 L6.3,1.85 C6.4,1.45 6.8,1.15 7.2,1.15 C7.5,1.25 7.8,1.45 7.9,1.85 L8,2.35 L10,2.35 L10,3.35 L4.2,3.35 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6,9.75 L7.6,9.75 L7.6,7.75 C7.6,7.45 7.3,7.15 7,7.15 C7,7.15 7,7.15 7,7.15 C6.7,7.15 6.4,7.45 6.4,7.75 L6.4,9.75 L4.4,9.75 C4.1,9.75 3.8,10.05 3.8,10.35 C3.8,10.65 4.1,10.95 4.4,10.95 L6.4,10.95 L6.4,12.95 C6.4,13.25 6.7,13.55 7,13.55 C7.3,13.55 7.6,13.25 7.6,12.95 L7.6,10.95 L9.6,10.95 C9.9,10.95 10.2,10.65 10.2,10.35 C10.1,9.95 9.9,9.75 9.6,9.75 Z",
    id: "Path"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPreferencesIconsTicketing, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/preferences_icons_Ticketing.a1064973.svg";
export { ForwardRef as ReactComponent };